export const ADD_MUSICIAN_TRANSACTIONS = 'ADD_MUSICIAN_TRANSACTIONS';

// This are the 4 main items.